import React from "react";
import PropTypes from "prop-types";
import { ExpandMore } from "@mui/icons-material";
import styles from "./atoms.Wizard.Step.module.scss";

export class Step extends React.Component {
  render() {
    const { content, title, goBackFunc, className, hideTitle, MobileConfigTags, paddingVariant, backIcon } = this.props;

    return (
      <div className={`${styles['step-container']} ${className}`}>
        {/* Only render the title if hideTitle is false */}
        {!hideTitle && (
          <div
            className={
              goBackFunc
                ? `${styles["step-title-wrapper"]} ${styles["go-back"]} ${MobileConfigTags ? styles["left-align"] : ""} ${paddingVariant || ""}` // ${paddingVariant ? styles[paddingVariant] : ""}
                : `${styles["step-title-wrapper"]} ${paddingVariant || ""}`
            }
            onClick={goBackFunc}
            data-automation-id="go-back-step"
          >
            {goBackFunc && (
              backIcon === "new" ? (
                <ExpandMore
                  style={{
                    transform: "rotate(90deg)",
                    color: "rgb(60,122,245)",
                    width: "24px",
                    height: "24px"
                  }}
                />
              ) : (
                <i
                  className={`step-back-icon icon-chevron-izquierda ${styles["step-back-icon"]} ${MobileConfigTags ? styles["left-align-icon"] : ""}`}
                ></i>
              )
            )}
            <div className={`${styles["step-title"]} ${MobileConfigTags ? styles["left-align-title"] : ""}`}>{title}</div>
          </div>
        )}

        <div className={styles["step-content-wrapper"]}>{content}</div>
      </div>
    );
  }
}

Step.propTypes = {
  content: PropTypes.any,
  title: PropTypes.string,
  goBackFunc: PropTypes.func,
  className: PropTypes.string,
  hideTitle: PropTypes.bool,
  MobileConfigTags: PropTypes.bool,
  paddingVariant: PropTypes.string,
  backIcon: PropTypes.string,
};

export default Step;